<template>
	<div>
        <b-overlay :show="tsLoading" no-wrap></b-overlay>
        <form >

            <b-form-group :label="$t('payments.selectCurrency')"  :description="$t('payments.selectCurrencyDesc')">
                <b-form-select
                v-model="form.currency"
                :options="currencies"
                required
                @change="tsSelected=[]"
                ></b-form-select>
            </b-form-group>
            <b-row>

                <b-col cols="12" md="5">
                    <b-form-group :label="$t('payments.expiredDate')">
                        <b-form-datepicker
                        size="sm"
                        class="mb-1"
                        locale="es"
                        v-model="form.date "
                        />
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5">
                    <b-form-group :label="$t('payments.hour')"  >
                        <vue-timepicker
                        required
                        manual-input
                        input-width="6em"
                        class="mb-1"
                        v-model="form.time"
                        />
                    </b-form-group>
                </b-col>
            </b-row>


           <section class="p-4">
                <b-table hover :items="itemsTableTs" :fields="fieldsTs" >
                    <template #cell(checkSelected)="row">
                    <md-icon
                    v-b-tooltip.hover="$t('payments.serviceInAnotherPayReq')"
                    v-if="form.id==-1 && row.item.havePayments"
                    :icon="'info'"
                    />
                    <b-form-checkbox v-else size="lg"  v-model="tsSelected" :value="row.item.id" :disabled="!row.item.canBeChecked"></b-form-checkbox>
                    </template>
                     <template #cell(bookingPriceTotal)="row">
                      ${{row.item.bookingPriceTotal}}
                    </template>
                </b-table>
                <h1 class="text-right text-success">${{totalCalculatedFormatted}} {{currencySelected}}</h1>
            </section>

            <b-button variant="primary" @click="save">{{ $t('global.save') }}</b-button>
        </form>
	</div>
</template>

<script>
import api from '../../../../api.js'
import numeral from 'numeral';
import VueTimepicker from "vue2-timepicker";
export default {
	components: {
		VueTimepicker
	},
	props: {
		modelId:{
            required:true,
            default:-1
        }
	},
	data(){
        const defaultForm= {
            id:-1,
            currency:"",
            total:0,
            status:"pending",
            date:"",
            time:"23:59",
        }
		return {
            hasErrors:false,
            form: {...defaultForm},
            tsSelected:[],
            tsLoading:false,
            listTs:[],
            fieldsTs: [
                {label:"",key:"checkSelected"},
                {label: this.$t('payments.serviceNumber'),key:"serviceNumber"},
                {label: this.$t('payments.salesChannel'),key:"salesChannelName"},
                {label: this.$t('payments.tripType'),key:"tripType"},
                {label: this.$t('payments.currency'),key:"bookingCurrency"},
                {label: "Total",key:"bookingPriceTotal"}
            ],

		}
	},
	methods: {
        getTransportServices(){
            this.tsLoading = true
            this.listTs    = [];
            api(this).get(`/reservations/${this.modelId}/payments/transport-services`).then( res => {
                this.listTs = [...res.data]
            })
            .catch(this.$root.handleRequestError)
            .finally(()=>{
                this.tsLoading= false;
            })
		},
        getDataForSave(){
            let data = {...this.form};
            data.total = this.totalCalculated
            data.transportServicesIds = this.tsSelected
            return data;
        },
        save(){
            if(this.validate()){
                this.tsLoading = true;
                api(this).post(`/reservations/${this.modelId}/payment`,this.getDataForSave())
                .then( (res) => {
                    this.$root.showAlert(this.$t('payments.successPay') + res.data.id)
                    this.$emit("done");
                })
                .catch(this.$root.handleRequestError)
                .finally(()=>{
                    this.tsLoading = false;
                })
            }
        },
        validate(){
			try{
				if(this.isEmpty(this.form.currency)){
					throw this.$t('payments.currencyReq');
				}
                if(this.isEmpty(this.form.time) || this.isEmpty(this.form.date)){
					throw this.$t('payments.expiredDateReq');
				}
                if(!(this.tsSelected.length>0)){
					throw this.$t('payments.serviceReq');
				}
                if(!(this.totalCalculated>0)){
					throw this.$t('payments.serviceAmountReq');
				}
			}catch(err){
				this.$root.showAlert(err,{variant:'danger'})
				return false;
			}
			return true;


		},
		isEmpty(val){
			return (val ===null || val === undefined || val==="");
		},

		reset(){
			Object.assign(this.$data, this.$options.data.apply(this))
			this.getSettingPointOfSale()
		},
        toLowercase(value){
            return value.toLowerCase();
        },
        toUppercase(value){
            return value.toUpperCase();
        }

	},
	computed:{
        currencySelected(){
            return this.toUppercase(this.form.currency)
        },
        currencies(){
            let currencies =[];
            this.listTs.forEach((ts)=>{
                let currencyCode = this.toLowercase(ts.bookingCurrency);
                let currencyLabel = this.toUppercase(ts.bookingCurrency);
                currencies[currencyCode] =  { value: currencyCode, text: currencyLabel };

            });
            return (Object.values(currencies));
        },
        itemsTableTs(){
            let items = [];
            this.listTs.forEach((ts)=>{
                let canBeChecked     = (this.toLowercase(ts.bookingCurrency) === this.toLowercase(this.form.currency))?true:false;
                let havePayments     = (ts.paymentStatus != "pending")
                let rowVariant       = (havePayments && this.form.id==-1)?"danger":""
                ts.havePayments      = havePayments,
                ts._rowVariant       = rowVariant
                ts.canBeChecked      = canBeChecked;
                items.push(ts)
            });
            items.sort((a)=>{
                return (a.havePayments)?-1:1;
            })
            return items;
        },
        totalCalculated(){
            let total = 0;
            this.tsSelected.forEach((tsId)=>{
                let found = this.listTs.find(element => (element.id === tsId ));
                total+=found.bookingPriceTotal;
            });
            return total;
        },
        totalCalculatedFormatted(){
            return numeral(this.totalCalculated).format('0,0.[00]');
        },
	},
	watch:{

	},
	mounted(){
        this.getTransportServices();
	},

}
</script>
